import WebPageSignUp from "./WebPageSignUp";
export default WebPageSignUp;